module.exports = __webpack_public_path__ + "media/images/logo_print-fdf2a30472b42e012deb31848f953793.png";